<template>
  <v-container>
    <v-row :class="{ read: notification.read }" no-gutters @click="markAsRead">
      <v-col :cols="showButtons ? 8 : 12" sm="6">
        <div v-if="notification.messageI18n == 'RESOURCE_NEW'">
          {{ 'New service published' }}
          <router-link
            class="on-hover-underline"
            :to="{ name: 'OverviewService', params: { id: notification.attributes.resourceId } }"
            >{{ notification.attributes.resourceName }}</router-link
          >
        </div>
        <div v-else-if="notification.messageI18n == 'EQUIPMENT_NEW'">
          {{ 'New equipment published' }}
          <router-link
            class="on-hover-underline"
            :to="{
              name: 'OverviewEquipment',
              params: { id: notification.attributes.equipmentId },
            }"
            >{{ notification.attributes.equipmentName }}</router-link
          >
        </div>
        <div v-else-if="notification.messageI18n == 'PATENT_NEW'">
          {{ 'New patent published' }}
          <router-link
            class="on-hover-underline"
            :to="{
              name: 'OverviewPatent',
              params: { id: notification.attributes.patentId },
            }"
            >{{ notification.attributes.patentName }}</router-link
          >
        </div>
        <div v-else-if="notification.messageI18n == 'PROVIDER_NEW'">
          {{ 'New provider added' }}
          <router-link
            class="on-hover-underline"
            :to="{
              name: 'OverviewProvider',
              params: { id: notification.attributes.providerId },
            }"
            >{{ notification.attributes.providerName }}</router-link
          >
        </div>
        <div v-else-if="notification.messageI18n == 'ORDER_REQUESTED'">
          {{ 'Order request for service' }}
          <router-link
            class="on-hover-underline"
            :to="{ name: 'OverviewService', params: { id: notification.attributes.resourceId } }"
            >{{ notification.attributes.resourceName }}</router-link
          >
          by <b>{{ notification.attributes.orderByFullName }}</b>
        </div>
        <div
          v-else-if="
            notification.messageI18n == 'ORDER_ACCEPTED_BY_PROVIDER' &&
              notification.attributes.resourceId
          "
        >
          {{ 'Order accepted by the provider for service' }}
          <router-link
            class="on-hover-underline"
            :to="{ name: 'OverviewService', params: { id: notification.attributes.resourceId } }"
            >{{ notification.attributes.resourceName }}</router-link
          >. {{ 'Check your email for further details' }}
        </div>
        <div
          v-else-if="
            notification.messageI18n == 'ORDER_ACCEPTED_BY_PROVIDER' &&
              notification.attributes.equipmentId
          "
        >
          {{ 'Order accepted by the provider for equipment' }}
          <router-link
            class="on-hover-underline"
            :to="{ name: 'OverviewEquipment', params: { id: notification.attributes.equipmentId } }"
            >{{ notification.attributes.equipmentName }}</router-link
          >. {{ 'Check your email for further details' }}
        </div>
        <div
          v-else-if="
            notification.messageI18n == 'ORDER_ACCEPTED_BY_PROVIDER' &&
              notification.attributes.patentId
          "
        >
          {{ 'Order accepted by the provider for patent' }}
          <router-link
            class="on-hover-underline"
            :to="{ name: 'OverviewPatent', params: { id: notification.attributes.patentId } }"
            >{{ notification.attributes.patentName }}</router-link
          >. {{ 'Check your email for further details' }}
        </div>
        <div
          v-else-if="
            notification.messageI18n == 'ORDER_REJECTED_BY_PROVIDER' &&
              notification.attributes.resourceId
          "
        >
          {{ 'Order rejected by the provider for service' }}
          <router-link
            class="on-hover-underline"
            :to="{ name: 'OverviewService', params: { id: notification.attributes.resourceId } }"
            >{{ notification.attributes.resourceName }}</router-link
          >
          . {{ 'Check your email for further details' }}
        </div>
        <div
          v-else-if="
            notification.messageI18n == 'ORDER_REJECTED_BY_PROVIDER' &&
              notification.attributes.equipmentId
          "
        >
          {{ 'Order rejected by the provider for equipment' }}
          <router-link
            class="on-hover-underline"
            :to="{
              name: 'OverviewEquipment',
              params: { id: notification.attributes.equipmentId },
            }"
            >{{ notification.attributes.equipmentName }}</router-link
          >
          . {{ 'Check your email for further details' }}
        </div>
        <div
          v-else-if="
            notification.messageI18n == 'ORDER_REJECTED_BY_PROVIDER' &&
              notification.attributes.patentId
          "
        >
          {{ 'Order rejected by the provider for patent' }}
          <router-link
            class="on-hover-underline"
            :to="{
              name: 'OverviewPatent',
              params: { id: notification.attributes.patentId },
            }"
            >{{ notification.attributes.patentName }}</router-link
          >
          . {{ 'Check your email for further details' }}
        </div>
        <div
          v-else-if="
            notification.messageI18n == 'ORDER_ACCEPTED_BY_RESEARCHER' &&
              notification.attributes.resourceId
          "
        >
          Offer accepted by <b>{{ notification.attributes.orderByFullName }}</b> for service
          <router-link
            class="on-hover-underline"
            :to="{ name: 'OverviewService', params: { id: notification.attributes.resourceId } }"
            >{{ notification.attributes.resourceName }}</router-link
          >
        </div>
        <div
          v-else-if="
            notification.messageI18n == 'ORDER_ACCEPTED_BY_RESEARCHER' &&
              notification.attributes.equipmentId
          "
        >
          Offer accepted by <b>{{ notification.attributes.orderByFullName }}</b> for equipment
          <router-link
            class="on-hover-underline"
            :to="{
              name: 'OverviewEquipment',
              params: { id: notification.attributes.equipmentId },
            }"
            >{{ notification.attributes.equipmentName }}</router-link
          >
        </div>
        <div
          v-else-if="
            notification.messageI18n == 'ORDER_ACCEPTED_BY_RESEARCHER' &&
              notification.attributes.patentId
          "
        >
          Offer accepted by <b>{{ notification.attributes.orderByFullName }}</b> for patent
          <router-link
            class="on-hover-underline"
            :to="{
              name: 'OverviewPatent',
              params: { id: notification.attributes.patentId },
            }"
            >{{ notification.attributes.patentName }}</router-link
          >
        </div>
        <div
          v-else-if="
            notification.messageI18n == 'ORDER_REJECTED_BY_RESEARCHER' &&
              notification.attributes.resourceId
          "
        >
          Offer rejected by <b>{{ notification.attributes.orderByFullName }}</b> for service
          <router-link
            class="on-hover-underline"
            :to="{ name: 'OverviewService', params: { id: notification.attributes.resourceId } }"
            >{{ notification.attributes.resourceName }}</router-link
          >
        </div>
        <div
          v-else-if="
            notification.messageI18n == 'ORDER_REJECTED_BY_RESEARCHER' &&
              notification.attributes.equipmentId
          "
        >
          Offer rejected by <b>{{ notification.attributes.orderByFullName }}</b> for equipment
          <router-link
            class="on-hover-underline"
            :to="{
              name: 'OverviewEquipment',
              params: { id: notification.attributes.equipmentId },
            }"
            >{{ notification.attributes.equipmentName }}</router-link
          >
        </div>
        <div
          v-else-if="
            notification.messageI18n == 'ORDER_REJECTED_BY_RESEARCHER' &&
              notification.attributes.patentId
          "
        >
          Offer rejected by <b>{{ notification.attributes.orderByFullName }}</b> for patent
          <router-link
            class="on-hover-underline"
            :to="{
              name: 'OverviewPatent',
              params: { id: notification.attributes.patentId },
            }"
            >{{ notification.attributes.patentName }}</router-link
          >
        </div>
        <div
          v-else-if="
            notification.messageI18n == 'ORDER_INVALIDATED_BY_PROVIDER' &&
              notification.attributes.resourceId
          "
        >
          {{ 'Order is marked as not still valid by the provider for service' }}
          <router-link
            class="on-hover-underline"
            :to="{ name: 'OverviewService', params: { id: notification.attributes.resourceId } }"
            >{{ notification.attributes.resourceName }}</router-link
          >
        </div>
        <div
          v-else-if="
            notification.messageI18n == 'ORDER_INVALIDATED_BY_PROVIDER' &&
              notification.attributes.equipmentId
          "
        >
          {{ 'Order is marked as not still valid by the provider for equipment' }}
          <router-link
            class="on-hover-underline"
            :to="{
              name: 'OverviewEquipment',
              params: { id: notification.attributes.equipmentId },
            }"
            >{{ notification.attributes.equipmentName }}</router-link
          >
        </div>
        <div
          v-else-if="
            notification.messageI18n == 'ORDER_INVALIDATED_BY_PROVIDER' &&
              notification.attributes.patentId
          "
        >
          {{ 'Order is marked as not still valid by the provider for patent' }}
          <router-link
            class="on-hover-underline"
            :to="{
              name: 'OverviewPatent',
              params: { id: notification.attributes.patentId },
            }"
            >{{ notification.attributes.patentName }}</router-link
          >
        </div>
        <div
          v-else-if="
            notification.messageI18n == 'ORDER_COMPLETED_BY_PROVIDER' &&
              notification.attributes.resourceId
          "
        >
          {{ 'Order is marked as completed by the provider for service' }}
          <router-link
            class="on-hover-underline"
            :to="{ name: 'OverviewService', params: { id: notification.attributes.resourceId } }"
            >{{ notification.attributes.resourceName }}</router-link
          >
        </div>
        <div
          v-else-if="
            notification.messageI18n == 'ORDER_COMPLETED_BY_PROVIDER' &&
              notification.attributes.equipmentId
          "
        >
          {{ 'Order is marked as completed by the provider for equipment' }}
          <router-link
            class="on-hover-underline"
            :to="{
              name: 'OverviewEquipment',
              params: { id: notification.attributes.equipmentId },
            }"
            >{{ notification.attributes.equipmentName }}</router-link
          >
        </div>
        <div
          v-else-if="
            notification.messageI18n == 'ORDER_COMPLETED_BY_PROVIDER' &&
              notification.attributes.patentId
          "
        >
          {{ 'Order is marked as completed by the provider for patent' }}
          <router-link
            class="on-hover-underline"
            :to="{
              name: 'OverviewPatent',
              params: { id: notification.attributes.patentId },
            }"
            >{{ notification.attributes.equipmentName }}</router-link
          >
        </div>
        <div v-else>{{ notification.message }}</div>
      </v-col>
      <v-col
        :cols="showButtons ? 4 : 12"
        :sm="showButtons ? 4 : 6"
        class="text-right"
        :md="showButtons ? 4 : 6"
      >
        <div class="time">
          <span class="notification-time">{{ timeAgo(notification.createdTimestamp) }}</span>
        </div>
      </v-col>
      <v-col v-if="showButtons" cols="12" md="2" lg="2" xl="2" sm="2" class="text-right">
        <div v-if="!notification.read">
          <v-btn elevation="0" small @click.stop="markAsRead()">
            {{ $t('mark-as-read') }}
          </v-btn>
        </div>
        <div v-else>
          <v-btn elevation="0" small @click.stop="markAsUnread()">
            {{ $t('mark-as-unread') }}
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <v-divider class="mt-2"></v-divider>
  </v-container>
</template>
<script>
import util from '@/mixins/util.js';

export default {
  name: 'NotificationItem',
  mixins: [util],
  props: {
    notification: {},
    showButtons: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    markAsRead() {
      this.markNotificationAsRead(this.notification.id).then(() => {
        this.notification.read = true;
      });
    },
    markAsUnread() {
      this.markNotificationAsUnread(this.notification.id).then(() => {
        this.notification.read = false;
      });
    },
  },
};
</script>

<style scoped>
.read {
  opacity: 0.5;
}

.time {
  color: gray;
  font-size: 14px;
}
</style>
